import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { hasPermission, firstAllowedPath } from "@/lib/permissions";

export default function ProtectedRoute({ children, redirectTo = "/adminxx1", roles, permission }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-violet-600" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to={redirectTo} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "parent" ? "/veli" : firstAllowedPath(user)} replace />;
  }
  if (permission && !hasPermission(user, permission)) {
    return <Navigate to={firstAllowedPath(user)} replace />;
  }
  return children;
}
